import { render } from "./Loading.vue?vue&type=template&id=62e8b3dc&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=62e8b3dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e8b3dc"]])

export default __exports__